// @ts-expect-error untyped module
import CountrySelect from 'ui-addon-i18n/components/CountrySelect';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useFilterChangeHandler } from '../../hooks/useFilterChangeHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CountryFilter({
  filter
}) {
  const params = useSearchParams();
  const handleChange = useFilterChangeHandler({
    filter,
    isMulti: true
  });
  if (!filter) return null;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: `eco_${filter.field}`,
      marginBlockStart: "200",
      children: filter.label
    }), /*#__PURE__*/_jsx(CountrySelect, {
      id: `eco_${filter.field}`,
      multi: true,
      onChange: handleChange,
      placeholder: filter.placeholder,
      value: params.getList(filter.field)
    })]
  });
}